module.exports = __webpack_public_path__ + "img/IconSupportBranco.14499bf1.png";